import {
  DEFAULT_CURRENCY,
  DEFAULT_LANGUAGE,
  formatStripeAmount,
  intlNumberFormat,
  revertStripeAmount,
  useTranslation,
} from "@bounce/i18n"

import type { CityData } from "@/libs/bounce/cities"
import { defaultPricing } from "@/utils/pricing"

interface FormatDecimalsProps {
  value: number
  locale?: string
  options?: Intl.NumberFormatOptions
}

export const useCityPriceInterpolations = (city: Pick<CityData, "lowestPrice" | "currency">) => {
  const { i18n } = useTranslation("marketing-ls-city")
  const price = city.lowestPrice || defaultPricing.defaultLowestLuggagePrice
  const priceInMainUnit = revertStripeAmount(price)
  const currency = city.lowestPrice ? city.currency : DEFAULT_CURRENCY

  const decimalPlaces = Number.isInteger(priceInMainUnit) ? 0 : 2

  const formatDecimals = ({ value, locale = i18n.language, options = {} }: FormatDecimalsProps) =>
    intlNumberFormat({
      locale,
      options: {
        style: "decimal",
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
        ...options,
      },
    }).format(value)

  return {
    currency,
    price: formatStripeAmount(price, currency, i18n.language),
    priceAmount: formatDecimals({ value: priceInMainUnit }),
    priceAmountForStructuredData: formatDecimals({
      value: priceInMainUnit,
      locale: DEFAULT_LANGUAGE,
      options: { useGrouping: false },
    }),
  }
}
